import
{
  AddTranslationRequestModel,
  CreateNoteRequestModel,
  CreateProductRequestModel,
  CreateVersionRequestModel,
  ImportVersionRequestModel,
  SendMailRequestModel,
  SubscribeUserRequestModel,
  Text,
  UpdateNoteRequestModel,
  UpdateProductRequestModel,
  UpdateVersionRequestModel,
} from "../../../services/api";

//Get
export class LoadProducts
{
  static readonly type = "[Product] Load Products";
}

export class LoadDeletedProducts
{
  static readonly type = "[Product] Load Deleted Products";
}

export class LoadDeletedVersions
{
  static readonly type = "[Product] Load Deleted Versions";
}

export class LoadProduct
{
  static readonly type = "[Product] Load Product";

  constructor(public productId: number) { }
}

export class GetProduct
{
  static readonly type = "[Product] Get Product";

  constructor(public productId: number) { }
}

export class LoadVersionsOfProduct
{
  static readonly type = "[Product] Load Versions Of Products";

  constructor(public productId: number) { }
}

export class LoadTagsOfProduct
{
  static readonly type = "[Product] Load Tags Of Products";

  constructor(public productId: number) { }
}

export class LoadJiraVersions
{
  static readonly type = "[Product] Load Jira Versions";

  constructor(public productId: number) { }
}

export class LoadNotesForVersion
{
  static readonly type = "[Product] Load Notes For Version";

  constructor(public versionId: number) { }
}

export class GetVersion
{
  static readonly type = "[Product] Get Version";

  constructor(public versionId: number) { }
}

export class LoadSubscriptionsForProduct
{
  static readonly type = "[Product] Load Subscriptions For Products";

  constructor(public productId: number) { }
}

export class CheckVersionOfProduct
{
  static readonly type = "[ProductApiStatus] Check Version of Product";

  constructor(public productId: number, public jiraKey: string) { }
}

export class CheckNoteOfVersion
{
  static readonly type = "[ProductApiStatus] Check Note of Version";

  constructor(public versionId: number, public jiraKey: string) { }
}

export class CheckNote
{
  static readonly type = "[ProductApiStatus] Check Note";

  constructor(public jiraKey: string) { }
}

//Delete
export class PermanentlyDeleteProduct
{
  static readonly type = "[Product] Permanently Delete Product";

  constructor(public productId: number) { }
}

export class DeleteProduct
{
  static readonly type = "[Product] Delete Product";

  constructor(public productId: number) { }
}

export class PermanentlyDeleteVersion
{
  static readonly type = "[Product] Permanently Delete Version";

  constructor(public versionId: number) { }
}

export class DeleteVersion
{
  static readonly type = "[Product] Delete Version";

  constructor(public versionId: number) { }
}

export class DeleteNote
{
  static readonly type = "[Product] Delete Note";

  constructor(public noteId: number) { }
}

export class DeleteSubscription
{
  static readonly type = "[Product] Delete Subscription";

  constructor(public subscription: SubscribeUserRequestModel) { }
}

export class Unsubscribe
{
  static readonly type = "[Product] Unsubscribe";

  constructor(public cancellationToken: string) { }
}

export class LoadEmailSubscriptions
{
  static readonly type = "[Product] Load Email Subscriptions";

  constructor(public productId: number, public languageId: number) { }
}

export class GetJiraVersion
{
  static readonly type = "[Product] Get Jira Version";

  constructor(public productId: number, public jiraKey: string) { }
}

export class GetVersionJiraIssue
{
  static readonly type = "[Product] Get Version Jira Issue";

  constructor(public versionId: number, public jiraKey: string) { }
}

export class GetJiraIssue
{
  static readonly type = "[Product] Get Jira Issue";

  constructor(public jiraKey: string) { }
}

//Post
export class RestoreDeletedProduct
{
  static readonly type = "[Product] Restore Deleted Product";

  constructor(public productId: number) { }
}

export class RestoreDeletedVersion
{
  static readonly type = "[Product] Restore Deleted Version";

  constructor(public versionId: number) { }
}

export class FilterProducts
{
  static readonly type = "[Product] Filter Products";

  constructor(public filterValue: string) { }
}

export class PostNote
{
  static readonly type = "[Product] Post Note";

  constructor(public note: CreateNoteRequestModel) { }
}

export class PostTag
{
  static readonly type = "[Product] Post Tag";

  constructor(public productId: number, public name: string, public description: string) { }
}

export class AddTagsToProduct
{
  static readonly type = "[Product] Add Tags To Product";

  constructor(public productId: number, public tagIds: number[]) { }
}

export class RemoveTagsFromProduct
{
  static readonly type = "[Product] Remove Tags From Product";

  constructor(public productId: number, public tagIds: number[]) { }
}

export class PostVersion
{
  static readonly type = "[Product] Post Version";

  constructor(public version: CreateVersionRequestModel) { }
}

export class SubscribeUser
{
  static readonly type = "[Product] Subscribe User";

  constructor(public userReq: SubscribeUserRequestModel) { }
}

export class Subscribe
{
  static readonly type = "[Product] Subscribe";

  constructor(public productId: number, public langId: number) { }
}

export class PostProduct
{
  static readonly type = "[Product] Post Product";

  constructor(public product: CreateProductRequestModel) { }
}

export class PostTranslation
{
  static readonly type = "[Product] Post Translation";

  constructor(public translation: AddTranslationRequestModel) { }
}

export class ImportJiraVersion
{
  static readonly type = "[Product] Import Jira Version";

  constructor(
    public version: ImportVersionRequestModel
  ) { }
}

export class ImportJiraIssue
{
  static readonly type = "[Product] Import Jira Issue";

  constructor(
    public versionId: number,
    public jiraIssueKey: string,
    public visibilityId: number
  ) { }
}

export class ExportJiraTranslationProduct
{
  static readonly type = "[Product] Export Jira Translation Product";

  constructor(
    public jiraKey: string,
    public productId: number,
    public languageId: number
  ) { }
}

export class ExportJiraTranslationVersion
{
  static readonly type = "[Product] Export Jira Translation Version";

  constructor(
    public jiraKey: string,
    public versionId: number,
    public languageId: number
  ) { }
}

export class SendEmail
{
  static readonly type = "[Product] Send Email";

  constructor(public mail: SendMailRequestModel) { }
}

//Put
export class PutNote
{
  static readonly type = "[Product] Put Note";

  constructor(public note: UpdateNoteRequestModel) { }
}

export class PutVersion
{
  static readonly type = "[Product] Put Version";

  constructor(public version: UpdateVersionRequestModel) { }
}

export class PutProduct
{
  static readonly type = "[Product] Put Product";

  constructor(public product: UpdateProductRequestModel) { }
}

export class PutText
{
  static readonly type = "[Product] Put Text";

  constructor(public text: Text) { }
}

//Other Actions
export class FilterTypeProducts
{
  static readonly type = "[Product] Filter Type Products";

  constructor(public filterValue: string[]) { }
}

export class FilterFavoritesProducts
{
  static readonly type = "[Product] Filter Favorite Products";

  constructor(public favoriteIds: number[]) { }
}

export class SelectVersion
{
  static readonly type = "[Product] Select Version";

  constructor(public versionId: number) { }
}

export class ClearProducts
{
  static readonly type = "[Product] Clear Products";
}

export class ClearVersions
{
  static readonly type = "[Product] Clear Versions";
}

export class ClearTags
{
  static readonly type = "[Product] Clear Tags";
}

export class ClearSelectedVersion
{
  static readonly type = "[Product] Clear Selected Version";
}

export class ClearEmailSubscriptions
{
  static readonly type = "[Product] Clear Email Subscriptions";
}

export class ClearProduct
{
  static readonly type = "[Product] Clear Product";
}


export class ClearJiraVersion
{
  static readonly type = "[Product] Clear Jira Version";
}

export class ClearJiraIssue
{
  static readonly type = "[Product] Clear Jira Issue";
}
